import { namespacer } from 'helpers'

const namespace = namespacer('HEADER')
export const OPEN_NAVIGATION = namespace('OPEN_NAVIGATION')
export const CLOSE_NAVIGATION = namespace('CLOSE_NAVIGATION')
